import React from 'react';
import { Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { TimesheetStatus } from '../timesheet/Timesheet';

export default class UnconfirmedAssignmentsAlert extends React.Component {
    render() {
        const { loading, job, timesheet } = this.props;

        if (
            loading ||
            !job ||
            !job.unconfirmedAssignments ||
            job.unconfirmedAssignments.length == 0
        ) {
            return null;
        }

        const notYetApproved = Boolean(
            timesheet.timesheetStatusId < TimesheetStatus.Approved
        );

        const areOrWere = notYetApproved ? 'are' : 'were';

        return (
            <Alert color="danger" fade={false}>
                <div className="d-flex">
                    <div className="mr-2">
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                    </div>
                    <div>
                        There {areOrWere} {job.unconfirmedAssignments.length}{' '}
                        unconfirmed assignments.
                        {notYetApproved && (
                            <>
                                If the employees are present but were unable to
                                confirm their assignment, please contact
                                dispatch.
                            </>
                        )}
                        <ul>
                            {job.unconfirmedAssignments.map((ua) => (
                                <li key={ua}>{ua}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </Alert>
        );
    }
}
